import {
  CarePrincipalDTO,
  // SignatureInstanceResponse,
} from "../../generated/api";

// COMFACT - KOMMER ATT TAS BORT 
// export const SET_CONTRACT = "SET_CONTRACT";
// export const SET_SIGNED_CONTRACT = "SET_SIGNED_CONTRACT";
// export const GET_SIGNED_CONTRACT = "GET_SIGNED_CONTRACT";
// export const GET_CONTRACT = "GET_CONTRACT";
// export const SIGN_CONTRACT = "SIGN_CONTRACT";
// export const SET_SIGNINSTANCE = "SET_SIGNINSTANCE";
export const GET_AVAILABLE_CAREPRINCIPALS_FOR_CONTRACT =
  "GET_AVAILABLE_CAREPRINCIPALS_FOR_CONTRACT";
export const SET_AVAILABLE_CAREPRINCIPALS_FOR_CONTRACT =
  "SET_AVAILABLE_CAREPRINCIPALS_FOR_CONTRACT";

// export const SET_SELECTED_CONTRACT = "SET_SELECTED_CONTRACT";

// export const CREATE_CONTRACT = "CREATE_CONTRACT";
 
// export const signContract = () => ({
//   type: SIGN_CONTRACT,
// });

// export const setContract = (contract: string) => ({
//   type: SET_CONTRACT,
//   contract,
// });

// export const setSignedContract = (signedContract: string) => ({
//   type: SET_SIGNED_CONTRACT,
//   signedContract,
// });

// export const setSignInstance = (signInstance: SignatureInstanceResponse) => ({
//   type: SET_SIGNINSTANCE,
//   signInstance,
// });

export const setAvailableCarePrincipalsForContract = (
  availableCarePrincipalsForContract: CarePrincipalDTO[]
) => ({
  type: SET_AVAILABLE_CAREPRINCIPALS_FOR_CONTRACT,
  availableCarePrincipalsForContract,
});

// export const setSelectedContract = (selectedContract: string) => ({
//   type: SET_SELECTED_CONTRACT,
//   selectedContract,
// });

const initialState = {
  // contract: null,
  // signedContract: null,
  // signInstance: null,
  availableCarePrincipals: null,
  // selectedContract: null,
};

export const contractReducer = (state = initialState, action: any) => {
  // const { contract } = action;
  // const { signedContract } = action;
  // const { signInstance } = action;
  const { availableCarePrincipalsForContract } = action;
  // const { selectedContract } = action;

  switch (action.type) {
    // case SET_CONTRACT:
    //   return { ...state, contract };
    // case SET_SIGNED_CONTRACT:
    //   return { ...state, signedContract };
    // case SET_SIGNINSTANCE:
    //   return { ...state, signInstance };
    case SET_AVAILABLE_CAREPRINCIPALS_FOR_CONTRACT:
      return { ...state, availableCarePrincipalsForContract };
    // case SET_SELECTED_CONTRACT:
    //   return { ...state, selectedContract };
    default:
      return state;
  }
};
